import { useState } from 'react'

import { styled } from 'styled-components'

import type {
  OrchestratedOfferingListingDetails,
  OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const StyledBanner = styled(Banner)`
  padding: 1rem 1.5rem;
  width: 100%;
`

export const HazmatInfoBanner = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const [showHazmatInfo, setShowHazmatInfo] = useState(
    !!listing.shipping?.hazmat?.isHazardous
  )

  if (!showHazmatInfo) return null

  return (
    <StyledBanner onDismiss={() => setShowHazmatInfo(false)}>
      <FormattedMessage id="Auction.details.hazmat.info" />
    </StyledBanner>
  )
}
